import {
  CustomHostnameStatus,
  DnsRecordStatus,
  DnsRecordType,
  DomainDnsRecord,
} from '@tribeplatform/gql-client/types'
import { T } from '@tribeplatform/react-components/i18n'
import { HelperText } from '@tribeplatform/react-ui-kit/HelperText'
import { Text } from '@tribeplatform/react-ui-kit/Text'

import { ApexWarning } from '../components/ApexWarning.js'
import { DnsRecordsTable } from '../DnsRecordsTable/index.js'

interface Props {
  domain: string
  isApex: boolean
  dnsRecords: DomainDnsRecord[]
  customHostnameStatus: CustomHostnameStatus
}

export const StatusPending = ({
  domain,
  isApex,
  dnsRecords,
  customHostnameStatus,
}: Props) => {
  const dnsMisconfigured = dnsRecords.some(
    record => record.status !== DnsRecordStatus.Healthy,
  )

  const cnameForApexMisconfigured =
    isApex &&
    dnsRecords.some(
      record =>
        record.type === DnsRecordType.CNAME &&
        record.status !== DnsRecordStatus.Healthy,
    )

  const isOnlyPendingHostname =
    !dnsMisconfigured && customHostnameStatus === CustomHostnameStatus.Pending

  return (
    <div className="flex flex-col space-y-3">
      <Text>
        <T
          defaultMessage="Please add the following DNS records to {domain} domain:"
          id="Admin.DomainTransfer.DnsInstructions"
          values={{ domain: <strong className="font-mono">{domain}</strong> }}
        />
      </Text>
      <DnsRecordsTable dnsRecords={dnsRecords} />
      {cnameForApexMisconfigured && <ApexWarning domain={domain} />}

      {isOnlyPendingHostname ? (
        <HelperText status="warn" highlighted>
          <Text variant="bodySm">
            <T
              defaultMessage="You have successfully configured the DNS records for {domain}. However, there are a few more things left on our side that we need to take care of, before you can finish the migration. Please check this page again in a few minutes to complete the transfer."
              id="Admin.DomainTransfer.PendingInternalOperations"
              values={{
                domain: <strong className="font-mono">{domain}</strong>,
              }}
            />
          </Text>
        </HelperText>
      ) : (
        <HelperText status="info" highlighted>
          <Text>
            <T
              defaultMessage="Once you have added the records, press the {button_name} button below to continue. Please be patient if you don’t see the changes immediately. DNS changes may take hours to propagate."
              id="Admin.DomainTransfer.DnsSubInstructions"
              values={{
                button_name: (
                  <strong>
                    <T
                      id="Admin.Domain.ValidateDns"
                      defaultMessage="Revalidate DNS settings"
                    />
                  </strong>
                ),
              }}
            />
          </Text>
        </HelperText>
      )}
    </div>
  )
}
